window.arCurriculumVitaeDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/curriculum-vitaes/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
